/**
 * AllMail created by johnmc on 05/11/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from '../app.component';

@Component({
  selector: 'all-mastersheet',
  template: '<dash></dash>',
  styles: [],
})

export class AllMastersheetComponent implements OnInit {
  @Input()
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    document.getElementById('title').innerText = 'Leads';
  }

}